import { FlexBox } from "@brg/ui";
import styled, { createGlobalStyle } from "styled-components";

export const Container = styled(FlexBox)`
  flex-flow: column;
  margin-bottom: 100px;
`;

export const GlobalChangeColorWrapper = createGlobalStyle`
  .app-wrapper {
    background-color: #E7E7E7!important;
  }
`import { FlexBox } from "@brg/ui";
import styled, { createGlobalStyle } from "styled-components";

export const Container = styled(FlexBox)`
  flex-flow: column;
  margin-bottom: 100px;
`;

export const GlobalChangeColorWrapper = createGlobalStyle`
  .app-wrapper {
    background-color: #E7E7E7!important;
  }
`